import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';

interface LeadershipStatusFilterProps {
  filterValue: string | null;
  updateFilters: (value: string) => void;
  disabled?: boolean;
}

const LeadershipStatusFilter: React.FC<LeadershipStatusFilterProps> = ({
  filterValue,
  updateFilters,
  disabled = false,
}) => {
  const handleChange = (event: SelectChangeEvent<string>) => {
    updateFilters(event.target.value);
  };

  return (
    <FormControl fullWidth variant="outlined" size="small">
      <InputLabel id="leadership-status">Leadership Status</InputLabel>
      <Select
        labelId="leadership-status"
        id="leadership-status-select"
        disabled={disabled}
        fullWidth
        value={filterValue ?? ''}
        label="Leadership Status"
        onChange={handleChange}
      >
        <MenuItem value="all">All</MenuItem>
        <MenuItem value="current">Current</MenuItem>
        <MenuItem value="past">Past</MenuItem>
      </Select>
    </FormControl>
  );
};

export default LeadershipStatusFilter;
